import { BaseContext } from '../../../utils/basecontext';
import { HttpClient } from '../../../utils/httpclient/httpclient';
import { POST, APIImpl } from '../api';
import { PasswordValidationCCRequest } from './passwordvalidationccrequest';

export class PasswordValidationCCAPI extends APIImpl<PasswordValidationCCRequest>
{
    constructor(httpClient:HttpClient, appContext: BaseContext){
        super(httpClient, appContext);
    }

    getHttpMethod(){
        return POST;
    }

    getAPIURL(): string
    {
        // https://www.callertunes.etisalat.ae/Middleware/api/adapter/v1/crbt/password-validation
        return "password-validation-3PP";
    }

    getRequestData()
    {
        return "msisdn=" + this.getRequest().getPasswordValidationCCRequest().getMsisdn() +"&"+
               "encryptedPassword="+ this.getRequest().getPasswordValidationCCRequest().getPassword() +"&"+
               "securityCounter="+this.getRequest().getPasswordValidationCCRequest().getSecurityCounter() +"&"+
               "username="+ this.getRequest().getPasswordValidationCCRequest().getUsername() +"&"+
               "language="+ this.getRequest().getPasswordValidationCCRequest().getLanguage() +"&"+
              "type="+ "ValidateDetails" +"&"+
               "clientTxnId="+ "21042020";
    }
    getHttpHeaders(): string
    {
         return {
            //   "fingerPrint" : "DD:EB:B6:7C:BD:27:AB:D2:9F:98:45:95:C1:65:49:5F:75:98:9E:31:83:5A:3D:E2:81:4B:E9:E3:F1:8B:B3:EC",
            // "appId" : "com.sixdee.callertunes_etisalat",
            "appId" : "com.tt_tunisia.callertunes",
            "appVersion" : "1.0.6",
            "channelId" : this.getRequest().getPasswordValidationCCRequest().getChannel(),
            "versionCode" : "7",
            "os" : "ios",
            "deviceId" : "0191212",
            "notificationTrackingId" : "",
            "accessToken" : this.getContext().getUserContext().getAccessToken(),
            "Cache-Control": "public, max-age=0, must-revalidate"
        } as any; 
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/passwordvalidationcc/passwordvalidationccapi.tsx